module.exports = __webpack_public_path__ + "static/media/my.c5f0c722.svg";